/**
 * 패널 플래닝 flattened canonical 참조 — Vuex 반응성 밖 (display id·resolve용)
 */

let panelFlattenedRef = null;

export function setPanelFlattenedRegistry(flattened) {
  panelFlattenedRef = flattened || null;
}

export function getPanelFlattenedRegistry() {
  return panelFlattenedRef;
}

export function clearPanelFlattenedRegistry() {
  panelFlattenedRef = null;
}
